import React from 'react';
import { EmptyState } from '../common';
import { formatDate } from '../../utils/formatters';

const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const formatHour = (h) => {
  if (h === 0) return '12:00 AM';
  if (h < 12) return `${h}:00 AM`;
  if (h === 12) return '12:00 PM';
  return `${h - 12}:00 PM`;
};

const AdminReportsTab = ({
  reportConfigs,
  loading,
  onCreate,
  onEdit,
  onDelete,
  onSendNow
}) => {
  const renderContent = () => {
    if (loading) {
      return <div className="loading">Loading...</div>;
    }

    if (!reportConfigs || reportConfigs.length === 0) {
      return (
        <EmptyState
          icon="📧"
          title="No weekly report recipients"
          message="Add a recipient to start receiving weekly site statistics via email."
        />
      );
    }

    return (
      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Recipient</th>
              <th>Day</th>
              <th>Hour</th>
              <th>Status</th>
              <th>Last Sent</th>
              <th>Created By</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {reportConfigs.map(cfg => (
              <tr key={cfg.id}>
                <td>{cfg.id}</td>
                <td>{cfg.recipient_email}</td>
                <td>{DAY_LABELS[cfg.day_of_week] || '-'}</td>
                <td>{formatHour(cfg.hour)}</td>
                <td>
                  <span className={`status-badge ${cfg.is_active ? 'active' : 'paused'}`}>
                    {cfg.is_active ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td>{cfg.last_sent_at ? formatDate(cfg.last_sent_at) : 'Never'}</td>
                <td>{cfg.created_by_name || cfg.created_by || '-'}</td>
                <td className="actions">
                  <button className="btn-edit" onClick={() => onSendNow(cfg)}>Send Now</button>
                  <button className="btn-edit" onClick={() => onEdit(cfg)}>Edit</button>
                  <button className="btn-delete" onClick={() => onDelete(cfg.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <div className="admin-actions-bar">
        <div style={{ flex: 1, color: '#666', fontSize: '14px' }}>
          Weekly site statistics are emailed to each active recipient on the configured day and hour
          (server local time). Use <strong>Send Now</strong> to dispatch a report immediately.
        </div>
        <button className="btn-create" onClick={onCreate}>
          Add Recipient
        </button>
      </div>
      {renderContent()}
    </>
  );
};

export default AdminReportsTab;
